export default {
	text: "Key result created by {changedBy}",
};
